import { render, staticRenderFns } from "./index1.vue?vue&type=template&id=6b22e7ba&scoped=true&"
import script from "./index1.vue?vue&type=script&lang=js&"
export * from "./index1.vue?vue&type=script&lang=js&"
import style0 from "./index1.vue?vue&type=style&index=0&id=6b22e7ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b22e7ba",
  null
  
)

export default component.exports